DJ.addBehavior('js-tutorial', '.js-tutorial', {
  attach: function (context, settings, behavior) {
    var i = 0;

    var holder = jQuery(context).find('.js-tutorial');

    holder.find('.play-tutorial').on('click', function(e) {
      var videoId = jQuery(this).attr('data-ytb').split('v=')[1];

      if (videoId) {
        var player = document.createElement('iframe');
        player.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0');
        player.setAttribute('frameborder', '0');
        player.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        player.setAttribute('allowfullscreen', '');
        player.classList.add('ytb-player');

        var modal = document.createElement('div');
        modal.classList.add('ytb-player-modal');

        var container = document.createElement('div');
        container.classList.add('ytb-player-container');

        var overlay = document.createElement('div');
        overlay.classList.add('ytb-player-container-overlay');

        // Close button
        var close = document.createElement('button');
        close.classList.add('ytb-player-close');
        close.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
          <rect x="9.19238" y="8.48535" width="25" height="1" transform="rotate(45 9.19238 8.48535)" fill="white"/>
          <rect x="8.48535" y="26.1628" width="25" height="1" transform="rotate(-45 8.48535 26.1628)" fill="white"/>
        </svg>`;

        modal.appendChild(overlay);

        container.appendChild(player);
        container.appendChild(close);
        modal.appendChild(container);

        document.body.appendChild(modal);

        // Close modal on close button click
        close.addEventListener('click', function () {
          document.body.removeChild(modal);
        });

        overlay.addEventListener('click', function () {
          document.body.removeChild(modal);
        });
      }
    });

    const header = document.querySelector(".header");

    // on window scroll
    let prevScrollPos = window.scrollY;
    window.addEventListener("scroll", () => {
      const currentScrollPos = window.scrollY;

      document.querySelectorAll('.biogaran-tutorial__section.is-showen .biogaran-tutorial__group-subtitle').forEach((el) => {
          const vh = window.innerHeight;
          const min = header.classList.contains('hide') ? 0 : header.clientHeight;
          const max = window.innerWidth < 768 ? min + 300 : min + 70;

          if (el.getBoundingClientRect().top < max && el.getBoundingClientRect().top > min) {
            if (document.querySelector(".biogaran-tutorial__group-anchor.active"))
              document.querySelector(".biogaran-tutorial__group-anchor.active").classList.remove("active");

            progress(el.id);
          } else if (prevScrollPos > currentScrollPos && el.getBoundingClientRect().top < vh && el.getBoundingClientRect().height > 0) {
            if (document.querySelector(".biogaran-tutorial__group-anchor.active"))
              document.querySelector(".biogaran-tutorial__group-anchor.active").classList.remove("active");

            progress(el.id);
          }

      })

      prevScrollPos = currentScrollPos;
    });

    jQuery('.biogaran-tutorial__sticky > button').on("click", function() {
      jQuery(this).toggleClass('is-open');


      const el = document.querySelector(".biogaran-tutorial__group-anchor.active");
      if (el)
        el.parentElement.style.setProperty("--top", (el.getBoundingClientRect().top - document.querySelector(".biogaran-tutorial__sticky").getBoundingClientRect().top - 24));
    });

    jQuery('.biogaran-tutorial__group-subtitle').on("click", function() {
      jQuery(this).toggleClass('is-closed');
    });

    jQuery('.biogaran-tutorial__section-anchor').on("click", function() {
      jQuery('.biogaran-tutorial__section-anchor.is-open').not(this).removeClass('is-open');
      jQuery(this).toggleClass('is-open');
    });

    document.querySelectorAll('.biogaran-tutorial__group-anchor').forEach((item) => {
      item.addEventListener("click", (event) => {
        jQuery('.biogaran-tutorial__sticky > button.is-open').removeClass('is-open');
        event.preventDefault();

        i = jQuery(item).closest('.first > li').index() + 1;
        update(false);

        const target = document.getElementById(
          item.getAttribute("href").substring(1)
        );

        if (window.innerWidth < 768) {
          setTimeout(() => {
            const targetPosition =
              target.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition =
              targetPosition - header.clientHeight - 90;
            window.scrollTo({
              top: offsetPosition - 50,
              behavior: "smooth",
            });
          }, 400); // <-- run after 400ms
        } else if (target.getBoundingClientRect().height > 0) {
            const currentScrollPosition = window.pageYOffset;
            const targetPosition =
              target.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition =
              targetPosition < currentScrollPosition
                ? targetPosition - header.clientHeight
                : targetPosition;

          window.scrollTo({
            top: offsetPosition - 50,
            behavior: "smooth",
          });
        }
      });
    });

    var next = holder.find('.btn-next');
    var prev = holder.find('.btn-prev');

    var max = holder
      .find('.biogaran-tutorial__section')
      .length;

    next.on('click', function(e) {
      e.preventDefault();
      holder.addClass('is-open');

      i++;
      var data = buildDataLayerObject({ event: 'virtualpage_view' }, {
        environement: settings.appEnv,
        page_template: 'Information page',
        content_group: getBreadcrumbLevelFromBiogaran(2),
        page_location: window.location.href,
        page_title: document.title || null,
        page_sub_category1: 'guide',
        step: i,
        step_name: getCurrentStepName(i, holder)
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
      update()


    });

    prev.on('click', function(e) {
      e.preventDefault();

      i--;
      update()
    });

    function update(animate = true) {
      if (i === 0) {
        next.find('.btn-txt').text('Commencer');
        prev.attr('disabled', true);
      } else {
        next.find('.btn-txt').text('Continuer');
        prev.removeAttr('disabled');
      }

      if (i === max) {
        next.attr('disabled', true);
      } else {
        next.removeAttr('disabled');
      }

      holder
        .children()
        .removeClass('is-showen');

      const el = holder
        .children()
        .eq(i)
        .addClass('is-showen');

      if (document.querySelector(".biogaran-tutorial__group-anchor.active"))
        document.querySelector(".biogaran-tutorial__group-anchor.active").classList.remove("active");
      if (document.querySelector("[href='#" + el.find("h3").attr("id") + "']"))
        progress(el.find("h3").attr("id"))

      if (animate) {
        jQuery('html, body').animate({
          scrollTop: jQuery('.biogaran-tutoriel-block').offset().top - header.clientHeight
        }, 400); // 400ms animation
      }

    }

    function progress(id) {
      const el = document.querySelector("[href='#" + id + "']");

      el.parentElement.style.setProperty("--top", (el.getBoundingClientRect().top - document.querySelector(".biogaran-tutorial__sticky").getBoundingClientRect().top - 24));
      el.classList.add("active");
    }
  },

  detach: function (context, settings) { }
});
function getBreadcrumbLevelFromBiogaran(n) {
  var items = Array.from(document.querySelectorAll('.breadcrumbs ul.hide-mobile > li'));
  if (items.length >= n) {
    var li = items[n - 1];
    var link = li.querySelector('a');
    var txt = link ? link.textContent : li.textContent;
    return cleanText(txt);
  }
  return null;
}
function cleanText(t) {
  return (t || '').replace(/\s+/g, ' ').trim() || null;
}
function getCurrentStepName(i, holder) {
  var $section = holder.children().eq(i);
  var t = cleanText($section.find('.biogaran-tutorial__group-subtitle').first().text());
  if (t) return t;
  t = cleanText($section.find('h3, h2').first().text());
  return t || null;
}
function buildDataLayerObject(base, props) {
  const obj = { ...base };
  for (const key in props) {
    obj[key] = props[key] ?? null;
  }
  return obj;
}
